import { render, staticRenderFns } from "./CBtn.vue?vue&type=template&id=2abcef93"
import script from "./CBtn.vue?vue&type=script&lang=js"
export * from "./CBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports